import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import actionType from '../../../Redux/Actions/ActionTypes';
import { LoadRegistrastionJournyData } from "../../../Redux/Actions/Actions";
import notify from '../../../Notifications/ToastifyActions';

function EditRecipientDataService(token,data) {
    console.log(token)
    return axios.post(`${CURRENT_API_URL}/account/editRecipientData`, data, {
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        notify.NotifySuccess("Your weekly recipient added successfully!");
        return res.data;
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while editing recipient data. please try again later.");
        return false;
    });
}


export default EditRecipientDataService;